import { apolloClient } from '~/apollo-client';
import { SignNowDocumentGroupStatus } from '~/typings/signnow';
import { REGENERATE_SIGNNOW_DOCUMENT_GROUP } from './regenerate-signnow-document-group.queries';

interface RegenerateSignNowDocumentGroupParams {
  envelopeIds: number[];
  isEmbedded?: boolean;
  redirectUri?: string;
}

export interface RegenerateSignNowDocumentGroupResponse {
  id: number;
  status: SignNowDocumentGroupStatus;
  signingUrl?: string | null;
  userId: number;
  inviteExpiresAt?: string | null;
  envelopeIds: number[];
}

export const regenerateSignNowDocumentGroup = async (
  params: RegenerateSignNowDocumentGroupParams,
): Promise<RegenerateSignNowDocumentGroupResponse> => {
  const { data } = await apolloClient.mutate<
    {
      regenerateSignNowDocumentGroup: {
        id: number;
        status: string;
        signingUrl?: string | null;
        userId: number;
        inviteExpiresAt?: string | null;
        envelopeIds: number[];
      };
    },
    { envelopeIds: number[]; isEmbedded?: boolean; redirectUri?: string }
  >({
    mutation: REGENERATE_SIGNNOW_DOCUMENT_GROUP,
    variables: {
      envelopeIds: params.envelopeIds,
      isEmbedded: params.isEmbedded,
      redirectUri: params.redirectUri,
    },
  });

  const result = data?.regenerateSignNowDocumentGroup;
  if (!result) {
    throw new Error('Failed to regenerate SignNow document group');
  }
  return {
    ...result,
    status: result.status as SignNowDocumentGroupStatus,
  };
};
